export default "<section>\n    <div class=\"footer-container\">\n        <p>Copyright © 2020 Brana Hnos</p>\n    </div>\n</section>  \n"